// Safely get property that might not exist from object that might not exist
export default function propertyOrNull(obj, ...props) {
    return props.reduce((obj, property) => {
        if (obj) {
            return obj[property] !== undefined ? obj[property] : null;
        } else {
            return null;
        }
    }, obj);
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/app/propertyOrNull.js